import ApiService from "@/services/Api"

export type AgentFormattedForList = {
	id: number
	name: string
	designation: string
	isActive: boolean
	lastUpdatedAt: Date
	lastInvokedAt: Date
}

type RetrieveAllAgentsFormattedForListResponse = {
	agents: Array<AgentFormattedForList>
}

export type CreateAgentResponse = {
	agent: {
		id: number
		name: string
	}
}

export type CreateAgentRequest = {
	name: string
	designation: string
}

export type UpdateAgentProfileInput = {
	agentId: number
	data: {
		name: string
		designation: string
	}
}

class AgentService {
	async retrieveAllAgentsFormattedForList (): Promise<AgentFormattedForList[]> {
		const response = await ApiService.get<RetrieveAllAgentsFormattedForListResponse>("/agents")

		return response.data.agents
	}

	async create (input: CreateAgentRequest): Promise<CreateAgentResponse["agent"]> {
		const response = await ApiService.post<CreateAgentResponse>("/agents", input)

		return response.data.agent
	}

	async updateAgentProfile (input: UpdateAgentProfileInput): Promise<void> {
		await ApiService.put(`/agents/${input.agentId}/profile`, input.data)
	}
}

export default new AgentService()
